module.exports = __webpack_public_path__ + "img/arrow-left-small.ee576d7b.svg";